import { vec3 } from 'gl-matrix';
export function isAcquisitionPlaneNormal(imageVolume, viewPlaneNormal) {
    const { direction, dimensions, spacing } = imageVolume;
    const scanAxis = vec3.fromValues(direction[6], direction[7], direction[8]);
    const cos = Math.abs(vec3.dot(scanAxis, viewPlaneNormal));
    const sin = Math.sqrt(Math.max(0, 1 - cos * cos));
    const halfDiagonal = Math.hypot(dimensions[0] * spacing[0], dimensions[1] * spacing[1]) / 2;
    return sin * halfDiagonal < spacing[2] / 2;
}
